import styled from "styled-components";

export const DisplayDiv = styled.div `
    display: flex;
    align-items: center;
    margin-bottom: 3px;
    width: 100%;
    justify-content: space-between;
    cursor: pointer;
`;
